import { createGlobalStyle, css } from "styled-components";

// IMPORTANT: please don't hard code
// colors,font-sizes,font-weights, and line-heights.
// Instead use the below values as a prop.
// Everything here is organized as the design.
export const lightTheme = {};

export const theme = {
  // Colors
  highlight: "#6E70B0",
  highlightDark: "#2B6A9D",
  highlightAlt: "#5E5DAA",
  subscribeAlt: "#9F6CB1",
  subscribe: "#AA65AB",
  success: "#3DD598",
  dangerTwo: "#EB5757",
  danger: "#FC5A5A",

  backgroundDark: "#202020",
  backgroundLight: "#282828",
  backgroundLighter: "#363636",
  backgroundLightest: "#4E4E4E",
  backgroundHover: "rgba(255, 255, 255, 0.07)",
  primary: "#6E70B0",
  palette: [
    "#AA64AC",
    "#9269AF",
    "#6E70B0",
    "#6A85B1",
    "#6896AC",
    "#65B3A1",
    "#C7AC65",
    "#C58763",
    "#BF6E61",
    "#B46174"
  ],
  primaryIndex: 2,

  backgroundTag: "#363636",
  backgroundTag2: "#484848",

  grey1: "#D5D5DC",
  grey2: "#979797",
  grey3: "#606060",
  grey4: "#484848",
  grey5: "#2E2E2E",
  link: "#cccccc",
  white: "#D5D5DC",
  realWhite: "#EEEEEE",
  whiteTransparent: "rgba(238, 238, 238, 0.4)",
  blackTransparent: "rgba(0, 0, 0, 0.4)",
  black: "#2E2E2E",

  // Text colors
  textLight: "#DEDEDE",
  textMedium: "#A6A6A6",
  textDark: "#A6A6A6",
  textGrey: "#979797",
  textExtraGrey: "#414141",

  // Fonts
  formFont:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  fontLight: "AvenirLTPro-Light",
  fontMedium: "AvenirLTPro-Medium",
  fontHeavy: "AvenirLTPro-Heavy",
  fontBlack: "AvenirLTPro-Black",

  borderRadiusContainers: "5px",
  boxShadow: "2px 0px 8px rgba(40, 40, 40, 0.79)",
  boxShadowBottom: "-4px 8px 8px rgba(40, 40, 40, 0.79)",

  breakpoints: {
    mobile: "800px",
    tablet: "1000px",
    desktop: "1351px",
    browse: "1300px"
  },

  iconSize: {
    xxs: "10px",
    xs: "14px",
    sm: "18px",
    md: "20px",
    lg: "22px",
    xl: "30px"
  },

  // Per-icon-button padding for ActionIconStrip rows. Driven by icon size.
  // Intentionally off the spacing scale (between spacing[2]=4 and
  // spacing[3]=8) because the 4px step is too coarse for icon-strip rhythm.
  iconButtonPad: {
    xs: "2px",
    sm: "7px",
    md: "7px",
    lg: "10px",
    xl: "12px"
  },

  editor: {
    backgroundDark: "#1F1F1F",
    backgroundMedium: "#282828",
    backgroundLight: "#363636",
    backgroundHighlight: "#4E4E4E",
    backgroundSuperHighlight: "#5A5A5A",
    backgroundSuperDuperHighlight: "#626262",

    // any icons should use the text properties
    textDark: "#727272",
    textMedium: "#A6A6A6",
    textLight: "#D8D8D8",

    iconLight: "#D8D8D8",
    iconMedium: "#363636",
    iconDark: "",

    highlight: "#6E70B0",
    highlightDark: "#465C64",

    success: "#3DD598",
    danger: "#EB5757",

    buttonRadius: "16px",
    circleRadius: "50%",
    containerRadius: "3px",
    headerHeight: "96px",
    editorHeaderHeight: "110px",
    editorHeaderHeightNoPx: "110",
    rulerHeight: "30px",
    rulerHeightNoPx: "30",
    laneControlsW: "240px",
    laneControlsWNoPx: "240",
    tightLaneControlsW: "380px",
    tightLaneControlsWNoPx: "380",
    laneHeight: "80px",
    laneHeightNoPx: "80",
    tightLaneHeight: "60px",
    tightLaneHeightNoPx: "60"
  },

  // ff: font-family, fs: font-size, fw: font-weight

  /******HEADERS*****/
  // h1 uses Black (900) for display impact; h2/h3 stay on Heavy (800)
  // so subheadings don't read as a wall of bold. Use the *Heavy variants
  // below if a caller explicitly wants the prior weight for h1, or the
  // fontBlack token if a caller wants to opt-in to Black on h2/h3.
  h1: { ff: "AvenirLTPro-Black", fs: "32px", letterSpacing: "0.1px" },
  h2: { ff: "AvenirLTPro-Heavy", fs: "24px", letterSpacing: "0.1px" },
  h3: {
    ff: "AvenirLTPro-Heavy",
    fs: "18px",
    letterSpacing: "0px",
    fw: 800
  },

  // Heavy-weight (800) heading variants preserved for callers that
  // explicitly want the prior weight.
  h1Heavy: { ff: "AvenirLTPro-Heavy", fs: "32px", letterSpacing: "0.1px" },
  h2Heavy: { ff: "AvenirLTPro-Heavy", fs: "24px", letterSpacing: "0.1px" },
  h3Heavy: {
    ff: "AvenirLTPro-Heavy",
    fs: "18px",
    letterSpacing: "0px",
    fw: 800
  },

  // h1 variations
  h1b: { fs: "24px", fw: 800 }, // default for h1

  /****PARAGRAPHS***/
  //    P1 Variations
  p1r: { ff: "AvenirLTPro-Roman", fs: "18px", letterSpacing: "0.1px" },
  p1m: { ff: "AvenirLTPro-Medium", fs: "18px", letterSpacing: "0.1px" },
  p1b: {
    ff: "AvenirLTPro-Heavy",
    fs: "18px",
    letterSpacing: "0.1px",
    fw: 800
  },

  //    P2 Variations
  p2r: { ff: "AvenirLTPro-Roman", fs: "16px", letterSpacing: "0.1px" },
  p2m: {
    ff: "AvenirLTPro-Medium",
    fs: "17px",
    letterSpacing: "0.1px",
    fw: 500
  },
  p2b: {
    ff: "AvenirLTPro-Heavy",
    fs: "16px",
    letterSpacing: "0.1px",
    fw: 800
  },

  //    P3 Variations
  p3l: { ff: "AvenirLTPro-Light", fs: "14px", letterSpacing: "0px" },
  p3r: { ff: "AvenirLTPro-Roman", fs: "14px", letterSpacing: "0px" },
  p3m: { ff: "AvenirLTPro-Medium", fs: "14px", letterSpacing: "0px" },
  p3b: {
    ff: "AvenirLTPro-Heavy",
    fs: "14px",
    letterSpacing: "0px",
    fw: 800
  },

  //    P4 Variations
  p4r: { ff: "AvenirLTPro-Roman", fs: "12px", letterSpacing: "0px" },
  p4m: { ff: "AvenirLTPro-Medium", fs: "12px", letterSpacing: "0px" },
  p4b: {
    ff: "AvenirLTPro-Heavy",
    fs: "12px",
    letterSpacing: "0px",
    fw: 800
  },

  p2: { fs: "16px", fw: "normal " },
  p3: { fs: "14px", fw: "normal" }, // default p tag props
  p4: { fs: "12px", fw: "normal" },

  // Line height variations
  lineHeight: {
    sm: "16px",
    md: "19px", // default for p tags
    lg: "24px" // default for h tags
  },

  // Padding Variations
  paddingContainersS: "24px",
  paddingContainersM: "40px",
  checkoutContainerMargin: "30px",

  br: {
    xs: "2px",
    sm: "4px",
    md: "8px",
    lg: "16px",
    pill: "9999px",
    circle: "50%",
    default: "8px"
  },

  // margin, padding, gap, etc.
  spacing: {
    0: "0px",
    1: "2px",
    2: "4px",
    3: "8px",
    4: "12px",
    5: "16px",
    6: "24px",
    7: "32px",
    8: "40px",
    9: "48px",
    10: "64px",
    11: "80px",
    12: "96px"
  },

  zIndex: {
    hide: -1,
    base: 0,
    raised: 1,
    above: 10,
    top: 100,
    dropdown: 1000,
    sticky: 1100,
    overlay: 1200,
    modal: 1300,
    popover: 1400,
    tooltip: 1500,
    notification: 1600,
    // editor-drawer specific z-index
    editorDrawer: 1300,
    // sidebar specific
    sidebar: 1002
  },

  baseHeaderHeight: "72px",
  headerTablePlusHeight: "96px",
  mobileFilterBarHeight: "44px",

  easing: {
    entering: "cubic-bezier(0.4, 0, 0.2, 1)", // fast --> slow
    exiting: "cubic-bezier(0.4, 0, 1, 1)" // fast start, quick stop
  },

  // Standardized outline/border tokens. Consume these via the
  // `outlinedSurface` css mixin (below) rather than hardcoding border
  // values per component. Resting/hover colors use alpha-on-white so
  // they read correctly on any background shade.
  border: {
    // weight scale — intentionally small
    hairline: "1px",
    standard: "1.5px",
    emphasis: "2px",

    // resting + interactive colors
    color: "rgba(255, 255, 255, 0.15)",
    colorHover: "rgba(255, 255, 255, 0.30)",
    colorActive: "#6E70B0", // = primary
    glow: "rgba(110, 112, 176, 0.25)", // focus ring

    // shared motion
    transition: "border-color 0.18s ease, box-shadow 0.18s ease",
    appearDuration: "0.4s"
  },

  gemscape: {
    staticHeight: "64px",
    progressOverlay: "rgba(110, 112, 176, 0.15)",
    scale: {
      hover: "scale(1.015, 1.03)",
      hero: "scale(1.05, 1.1)",
      activePlay: "scale(1.02, 1.04)",
      heroPlay: "scale(1.03, 1.06)",
      encompassing: "scale(1.025, 1.05)"
    },
    easingStyle: {
      elasticPop: "cubic-bezier(0.34, 1.56, 0.64, 1)"
    }
  },

  /**
   * Components
   */
  sidebar: {
    width: "218px",
    rangeAnimationTime: 200, // in ms
    filterTopPadding: "24px",
    filterBottomPadding: "8px",
    filterItemGap: "12px"
  },

  sidebarFilters: {
    minHeight: "375px"
  },

  canvasVideo: {
    height: "400px"
  },

  playerDrawer: {
    height: "100px"
  },

  thumbnail: {
    height: "54px",
    width: "54px",
    borderRadius: "6px"
  },
  thumbnailMedium: {
    height: "105px",
    width: "105px",
    borderRadius: "8px"
  },
  thumbnailLarge: {
    height: "156px",
    width: "156px",
    borderRadius: "10px"
  },

  playIcon: {
    height: { default: "45px" },
    width: { default: "45px" }
  },

  button: {
    height: {
      default: "22px"
    },
    width: {
      default: "67px"
    }
  },

  filterPanelButton: {
    borderRadius: "6px",
    hoverBrightness: 1.2,
    selectedHoverBrightness: 1.2,
    pressedBrightness: 0.9,
    transitionDuration: "0.3s",
    fillDelay: "0.1s",
    fillAnimationHold: 400 // ms
  },

  filters: {
    leftPosition: "47px",
    sliderPadding: "7px",
    width: {
      default: "124px",
      sm: "67px",
      md: "93px",
      lg: "124px"
    },
    height: {
      default: "22px",
      xs: "12px",
      sm: "18px",
      md: "21px",
      //  sm: "18px",
      //  md: "21px",
      lg: "22px",
      xl: "48px"
    },
    key: {
      height: "24px",
      width: "104px"
    },
    switch: {
      height: "24px",
      width: "48px"
    },
    rangeSlider: {
      tooltip: {
        content: {
          maxWidth: "180px"
        }
      }
    }
  },

  trackTable: {
    containerMargin: "27px",
    gridColumns: {
      full: "60px 115px 1.5fr 30px 30px 1.5fr 20px",
      mobile: "60px 1fr 30px"
    },
    row: {
      paddingTop: "14px",
      paddingBottom: "13px",
      columnGap: "16px"
    }
  },

  trackInfoSections: {
    height: "82px",
    dropdownOffset: "-82px",
    borderRadius: "10px"
  },

  trackActions: {
    height: "32px"
  },

  dropdownMenu: {
    itemHeight: "34px",
    gap: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)"
  },
  downloadModal: {
    projectImage: {
      size: "82px",
      marginRight: "20px",
      marginBottom: "10px"
    },
    projectSelect: {
      height: "36px",
      maxWidth: "320px"
    },
    variations: {
      minHeight: "72px",
      fadeInDuration: "220ms"
    }
  },

  scrollbar: {
    width: { default: "8px" }
  },

  actionsButton: {
    height: {
      default: "34px"
    },
    width: {
      default: "34px"
    }
  },

  headerWidget: {
    height: {
      default: "180px"
    }
  },

  autocomplete: {
    gap: "8px",
    rowHeight: "34px",
    borderRadius: "10px",
    iconPadding: "8px"
  },
  searchBar: {
    height: "24px",
    width: "290px"
  },
  variationsPane: {
    marginTop: "85px",
    dropdownTable: {
      gridTemplateColumns: "115px 2fr 30px 20px"
    }
  }
};

export const GlobalStyle = createGlobalStyle`
  html { 
    font-family: ${props => props.theme.p2r.ff};     
    background-color:${props => props.theme.bg1}; 
  }
    
  @supports (font-variation-settings: normal) {
    html {  
        box-sizing: border-box;
    
    }
  }

    /*
   border width also accounts for the box width.
*/
*,
*:before,
*:after {
  box-sizing: inherit;
}




    body{
        margin: 0px;
        padding: 0px;
        font-family: ${theme.p2r.ff};     
        letter-spacing: 0.1px;
        color: ${theme.textLight};
        background-color:${theme.backgroundLight};


    }

    h1, h2, h3, h4, h5, h6, p {
        padding: 0px;
        font-family: ${theme.h1.ff
  }, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
        word-break: break-word;
       
    }

    h1, h2, h3, h4, h5, h6 {
        line-height: 24px;
    }

    h1 {
        font-size: ${theme.h1.fs};
        font-family: ${theme.h1.ff};
        color: ${theme.textLight};
    }

    h3 {
        font-family: ${theme.h3.ff};
        font-size: ${theme.h3.fs};
    }

    p {
        margin-bottom:0px ;
        padding:0px;
        font-family: ${theme.p3r.ff
  }, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
        font-size: ${theme.p3r.fs};
        line-height: ${theme.lineHeight.md};
        color: ${theme.textLight};;
    }

    button {
        border: none;
        outline: none;
        cursor: pointer;
        /* font-family: ${theme.p3r.ff}; */
        font-size: ${theme.p3r.fs};  
    }

    a {
      text-decoration: none;
    }


    /* Text Tag Variations */
    .p1b{
      font-size: ${theme.p1b.fs};
      font-family: ${theme.p1b.ff};
    }

    .p2b {
      font-size: ${theme.p2b.fs};
      font-family: ${theme.p2b.ff};
     }

     .p4m {
        font-size: ${theme.p4m.fs};
        font-family: ${theme.p4m.ff};
      }
      .p4b {
        font-size: ${theme.p4b.fs};
        font-family: ${theme.p4b.ff};
      }

      .p3m{
        font-size: ${theme.p3m.fs};
        font-family: ${theme.p3m.ff};
        line-height: 19px;
      }

      .p3r {
        font-size: ${theme.p3r.fs};
        font-family: ${theme.p3r.ff}; 
      }

      .p3b{
        font-size: ${theme.p3b.fs};
        font-family: ${theme.p3b.ff}; 
      }
      
      .h2 {
        font-family: "AvenirLTPro-Heavy";
        font-size: ${theme.h2.fs};
        line-height: 25px;
      }

      .h3 {
        font-family: "AvenirLTPro-Heavy";
        font-size: ${theme.h3.fs};
        line-height: 25px;
      }

      
      .grey {
        color: ${theme.textDark};
      }

      .highlight {
        color: ${theme.highlight};

      }

      .pointer {
        cursor: pointer;
      }

      .underline{
        text-decoration: underline;
      }

      .ws-nowrap{
        white-space: nowrap;
      }

      .width-fc{
        width: fit-content;
      }

      .flex {
        display: flex; 
      }
      .align-c {
        align-items: center;
      }
    .row {
      display: flex;
      align-items: center;
    }

    .image-border-radius{
      border-radius: 5px;
    }


/***********************************************/



/* GLOBAL INPUT STYLES */
  input:-webkit-autofill, 
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    ${"" /* -webkit-transition-delay: 99999999s; */}
    -webkit-box-shadow: 0 0 0 30px #1F1F1F inset ;
    -webkit-text-fill-color: rgba(255, 255, 255, 0.7);
    border: none;
    caret-color: white;
    transition: background-color 5000s ease-in-out 0s;

  }

  .ant-dropdown-menu-item, .ant-dropdown-menu-submenu-title {
    transition: all 0.4s;
  }
  .ant-form .ant-input::-webkit-input-placeholder {
      color: ${props => props.theme.textGrey};
    }
     .ant-form .ant-input::-moz-placeholder {
      /* Firefox 19+ */
      color: ${props => props.theme.textGrey};
    }
     .ant-form .ant-input:-ms-input-placeholder {
      /* IE 10+ */
      color: ${props => props.theme.textGrey};
    }
    .ant-form .ant-input:-moz-placeholder {
      /* Firefox 18- */
      color: ${props => props.theme.textGrey};
    }
   .ant-form .ant-input{
      border: none;
    }
    .has-error .ant-form-explain,
  .has-error .ant-form-split {
    color: ${props => props.theme.danger};
    margin-bottom: 8px;
    margin-top: 4px;
  }

  .ant-form-item-control-wrapper  .has-error .ant-input:hover input {
    border: 2px ${props => props.theme.danger} solid;
    background-color: ${props => props.theme.backgroundDark};
  }
  .ant-form-item-control-wrapper .has-error .ant-input-affix-wrapper .ant-input:hover {
    border: 2px ${props => props.theme.danger} solid;
  }

  .ant-form-item-control-wrapper .has-error .ant-form-item-children .ant-input {
    border: 1px ${props => props.theme.danger} solid;
    background-color: ${props => props.theme.backgroundDark};

  }

/*******************************************************************/


/* MODAL GLOBAL STYLES */

  .ant-modal .ant-modal-body {
    padding: 0px;
  }

  .ant-alert-warning, .ant-alert-with-description {
    padding: 15px 25px 15px 64px;
    color:${props => props.theme.textLight};
    border: 0px;
    background-color: #b79455;
  }
  
  .ant-alert-with-description .ant-alert-message {
    color:${props => props.theme.textLight};
    font-family: 'AvenirLTPro-Heavy';
  }
  .ant-alert-warning .ant-alert-icon {
    color:${props => props.theme.textLight};
  }

  .ant-modal {
    width: fit-content;
  }

  .ant-modal .ant-modal-content{
    background-color: ${props => props.theme.backgroundDark};
    max-width: max-content;
    margin: 0 auto;
    border-radius: 10px;
    overflow: hidden;
  }

  .ant-modal-close-x {
    cursor: pointer;
  }

  .ant-modal-confirm-body > .anticon + .ant-modal-confirm-title + .ant-modal-confirm-content{
    color:${props => props.theme.textDark};
    font-family:${props => props.theme.p3r.ff};
    font-size:${props => props.theme.p3r.fs};
  }


  .has-error .ant-form-explain, .has-error .ant-form-split{
    max-width:320px;
  }

  .ant-modal-confirm-body > .anticon {
    background: url(${require("./assets/confirmation-icon.svg")}) no-repeat center;
    background-size: 18px;
    > svg {
      fill: none;
    }
  }

  .ant-modal-confirm-body .ant-modal-confirm-title{
    color:${props => props.theme.textLight} !important;
    font-family:${props => props.theme.p2m.ff};
    font-size:${props => props.theme.p2m.fs};
  }
  .ant-modal-confirm .ant-modal-confirm-btns button:first-child{
    background:${props => props.theme.backgroundTag};
    color:${props => props.theme.textLight};
  }

  .ant-modal-confirm .ant-modal-confirm-btns button {
    border:none;
    border-radius: ${props => props.theme.br.lg};
    font-family:${props => props.theme.p3b.ff};
    font-size:${props => props.theme.p3b.fs};
  }

  .ant-modal-confirm .ant-modal-confirm-btns button + button{
    background:${props => props.theme.highlight};
  }

  .ant-modal-close {
    cursor: default !important;
  }

  .ant-modal  .ant-modal-close-icon {
    color: ${theme.textLight};
    font-size: 16px;
    margin-top: 30px;
    display: none;
  }

  /**
   * antd 3.x defaults Tooltip zIndex to 1060, which sits below our modal
   * zIndex token (theme.zIndex.modal = 1300). Without this override,
   * tooltips inside modals render underneath the modal mask.
   */
  .ant-tooltip {
    z-index: ${theme.zIndex.tooltip} !important;
  }

/**********************************************/

.ant-dropdown-menu-sub {
  background-color: ${theme.editor.backgroundMedium};
}

/**************************************** */

.ant-drawer  .ant-drawer-body {
  padding: 0px;
}

  .ant-drawer .ant-drawer-wrapper-body {
    background: ${theme.backgroundDark};
  }


  .ant-drawer-content-wrapper{
    width: 420px;
  }
  
  .ant-modal-confirm .ant-modal-body {
    padding: 32px 32px 24px !important;
  }

@media (max-width: 430px ) {
  .ant-drawer-content-wrapper{
    width: 100%;
  }
}
/***************************** */


/*********  ant notification styles ******/

.ant-notification .ant-notification-notice {
  background-color: ${props => props.theme.backgroundDark} ;
}
.ant-message-notice-content {
  background: #232323 !important;
  color:${props => props.theme.textLight}
}

.ant-message-custom-content .anticon svg{
  fill:${props => props.theme.highlight};
}
.ant-notification .ant-notification-notice-with-icon .ant-notification-notice-message {
  color:  ${props => props.theme.textLight} ;
}

.ant-notification .ant-notification-close-icon{
  color:  ${props => props.theme.textLight} ;
}

/*****************************************/


/************** tool tip style*******************/

.ant-tooltip.tool-tip-class.ant-tooltip-placement-right .ant-tooltip-inner {
    max-height: calc(100vh - 110px - 96px);
    overflow-y: auto;
    width: 340px;
    padding: 0px;



  ::-webkit-scrollbar {
    width: 8px;
    opacity: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    opacity: 0;
    width: 15px;
    background-color: ${props => props.theme.backgroundDark};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb { 
    background: rgba(255, 255, 255, 0.06);
    opacity: 0.6;
    border-radius: 2px;
  }
}

.ant-tooltip.tool-tip-class.ant-tooltip-placement-right .ant-tooltip-inner .tooltip-filter-container {
    background: red;
    height: 100%;
    background-color: ${props => props.theme.backgroundDark};
    width: 100%;
    padding: 24px 24px 3px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.ant-tooltip.tool-tip-class.ant-tooltip-placement-right .ant-tooltip-arrow{
  display: none;
}

.ant-tooltip.tool-tip-class.large.instruments.ant-tooltip-placement-right{ 
  top: 96px !important;
  position: fixed;
}
.ant-tooltip.tool-tip-class.large.tags.ant-tooltip-placement-right{ 
  top: 96px !important;
  position: fixed;

}
.ant-tooltip.tool-tip-class.large.keys.ant-tooltip-placement-right{ 
  top: 96px !important;
  position: fixed;
}

.ant-tooltip.tool-tip-class.small.ant-tooltip-placement-right{
  position: fixed;
}

.ant-tooltip.tool-tip-class.small.ant-tooltip-placement-right .ant-tooltip-inner {
  top: 8px;
}


.ant-tooltip.small.ant-tooltip-placement-right .ant-tooltip-inner{
  height: 80px;
  position: relative;
  display: block;
  overflow: hidden;
  padding: 24px;

}

.range-tooltip-browse {
  left: 188px !important;
}

.range-tooltip-setting {
  left: 416px !important; 
}

.range-tooltip  .ant-tooltip-arrow {
  width: 24px;
  height: 24px;
}

.range-tooltip  .ant-tooltip-arrow  {
  top: 0px !important;
}

.range-tooltip .ant-tooltip-arrow::before {
  width: 24px !important; 
  height: 24px !important;
  background-color: ${theme.backgroundDark};

}

.range-tooltip .ant-tooltip-inner {
  background: ${theme.backgroundDark};
  position: relative;
  top: -17px;
}

.ant-tooltip-inner {
  position: relative;
  bottom: -17px;
}

.ant-tooltip-inner, 
.ant-tooltip-arrow::before,
.ant-tooltip-inner {
  background: ${theme.backgroundDark};
}

.palette-tooltip .ant-tooltip-inner {
  background: ${theme.backgroundDark};
  bottom: -5px;
  padding: 6px 18px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, .65);
}

.avatar-tooltip  .ant-tooltip-arrow {
  width: 24px;
  height: 24px;
}

.avatar-tooltip .ant-tooltip-arrow::before {
  width: 24px !important; 
  height: 24px !important;
  background-color: ${theme.backgroundDark};
  top: -18px !important;
}

.avatar-tooltip .ant-tooltip-inner {
  background: ${theme.backgroundDark};
  position: relative;
  top: -10px;
}

.tooltip-sm .ant-tooltip-inner {
    font-size: 11px;
    min-height: auto;
    padding: 2px 6px;
    display: flex;
    justify-content: center;
}

/************** popover style*******************/

.ant-popover-inner, .ant-popover-arrow {
  background-color: ${props => props.theme.backgroundDark} !important;
  border-top-color: ${props => props.theme.backgroundDark} !important;
  border-right-color: ${props => props.theme.backgroundDark} !important;
  border-bottom-color: ${props => props.theme.backgroundDark} !important;
  border-left-color: ${props => props.theme.backgroundDark} !important;
}

.ant-popover-message {
  .ant-popover-message-title {
    color: ${props => props.theme.textLight} !important;
    font-family: ${props => props.theme.p3m.ff} !important;
    font-size: ${props => props.theme.p3m.fs} !important;
  }

  .anticon-exclamation-circle {
    color: ${props => props.theme.highlight} !important;
  }
}

.ant-popover-buttons {
    .ant-btn {
      border: none;
      outline: none;
      cursor: pointer;
      font-size: ${theme.p3m.fs};
      border-radius: ${props => props.theme.br.lg};
      color: ${({ theme }) => theme.textLight};
      padding: 2px 12px;
      transition: transform 0.3s ease-in-out;
    }

    .ant-btn:hover {
      transform: scale(1.05);
    }

    .ant-btn:not(.ant-btn-primary) {
      background: ${({ theme }) => theme.backgroundTag};
      color: ${({ theme }) => theme.textLight};
    }
}

/*********************************************/

  .ant-calendar{
     background:${props => props.theme.backgroundDark} !important;
     color:${props => props.theme.textLight};
     width:334px;
     border:none !important;


    .ant-calendar-my-select a {
      color:${props => props.theme.textLight};
    }

    .ant-calendar-date{
      color:${props => props.theme.textLight};

      &:hover{
        background:${props => props.theme.highlight};
        color:${props => props.theme.textLight};
      }
    }
    .ant-calendar-header, .ant-calendar-input-wrap{
      border-bottom:1px solid ${props => props.theme.backgroundTag};
    }

    .ant-calendar-footer{
        border-top:1px solid ${props => props.theme.backgroundTag};
    }


    .ant-calendar-input{
      background:${props => props.theme.backgroundDark} !important;
     color:${props => props.theme.textLight};

     &:hover .anticon{
       display:none !important;
     }
    }

    .ant-calendar-today-btn{
        color:${props => props.theme.textLight};
    }

    .ant-calendar-selected-day .ant-calendar-date{
      background:${props => props.theme.highlight};
      outline:none;
    }

    .ant-calendar-selected-day .ant-calendar-date:hover{
      background:${props => props.theme.highlight}
    }
  }


   form .ant-input-number-handler-wrap{
     opacity:0 !important; 
     display:none !important;
   }

   .ant-input-number{
     display:flex;
     align-items:center;
   }

    .ant-form-item-label > label {
      color: ${props => props.theme.textLight};
      font-family:${props => props.theme.p2m.ff};
    }
    .ant-form-item-label > label::after {
      content: "";
    }

/******************************************************************************** */

  .project-select-dropdown ul {
    min-width: 250px;
  }

  .license-select ul{
    width:199px;
  }

  /******************************************************************************** */

// ant checkbox styles
.ant-checkbox-inner {
  border: none;
  border-radius: 4px;
  background-color: #363636;
}

.clickable-area {
  padding: 30px;
  margin: -30px;
  cursor: pointer;
}

.ant-switch-checked {
  background-color: ${props => props.theme.primary};

  &::after {
    background-color: ${props => props.theme.textLight};
  }
}

/******************************************************************************** */

.ant-select-selection {
  background-color: ${props => props.theme.backgroundLighter};
  color: ${props => props.theme.textLight};
  border: none;

  &:hover,
  &:focus {
    border: none;
    box-shadow: none;
  }
}

.ant-select-focused .ant-select-selection {
  border: none;
  box-shadow: none;
}

.ant-select-selection__placeholder,
.ant-select-search__field__placeholder {
  color: ${props => props.theme.textMedium};
}

.ant-select-selection__choice {
  background-color: ${props => props.theme.backgroundLightest};
  color: ${props => props.theme.textLight};
  border: none;
}

.ant-select-selection__choice__remove {
  color: ${props => props.theme.textLight};
}

.ant-select-selection--multiple .ant-select-selection__choice {
  background-color: ${props => props.theme.backgroundLightest};
  color: ${props => props.theme.textLight};
  border: none;
}

.ant-select-arrow {
  color: ${props => props.theme.textLight};
}

.ant-select-dropdown {
  background-color: ${props => props.theme.backgroundLighter};

  .ant-select-dropdown-menu-item {
    color: ${props => props.theme.textLight};
    background-color: ${props => props.theme.backgroundLighter};

    &:hover,
    &.ant-select-dropdown-menu-item-active {
      background-color: ${props => props.theme.backgroundLightest};
    }
  }

  .ant-select-dropdown-menu-item-selected {
    background-color: ${props => props.theme.backgroundLightest};
    color: ${props => props.theme.textLight};
    font-weight: normal;
  }
}
`;

// Shared scrollbar styles
export const scrollbarStyles = css`
  &::-webkit-scrollbar {
    width: ${theme.scrollbar.width.default};
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
  }

  &:hover::-webkit-scrollbar-track {
    background-color: ${theme.backgroundDark};
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.06);
  }
`;

// Standardized outline/border treatment. Compose into a styled-component
// and override per-context (e.g. `border-width: ${theme.border.emphasis}`).
// Active state triggers on `.is-active`, `:focus`, or `:focus-within`.
export const outlinedSurface = css`
  border: ${theme.border.standard} solid ${theme.border.color};
  border-radius: ${theme.br.md};
  transition: ${theme.border.transition};

  &:hover {
    border-color: ${theme.border.colorHover};
  }

  &.is-active,
  &:focus,
  &:focus-within {
    border-color: ${theme.border.colorActive};
    box-shadow: 0 0 0 3px ${theme.border.glow};
  }
`;

// Opt-in on-load animation for surfaces that appear (popups, cards).
// Keep separate from `outlinedSurface` so inputs don't animate on render.
export const outlineAppear = css`
  @keyframes outline-appear {
    from {
      border-color: transparent;
      box-shadow: 0 0 0 0 ${theme.border.glow};
    }
    to {
      border-color: ${theme.border.color};
      box-shadow: 0 0 0 3px transparent;
    }
  }
  animation: outline-appear ${theme.border.appearDuration}
    ${theme.easing.entering};
`;

export const fieldLabel = css`
  color: ${theme.textLight};
  font-family: ${theme.p2m.ff};
  font-size: ${theme.p3m.fs};
  margin-bottom: 8px;
`;

/** Can this replace src/pages/Private/Settings/GeneralSettings/formSchema.js  ??
 * Can this replace src/components/InviteForm/schema.js ??
 * Can this replace src/components/InviteForm/index.js ??
 * They are all the same but for different components
 **/
export const inputStyle = {
  width: "100%",
  height: "40px",
  border: "none",
  borderRadius: theme.borderRadiusContainers,
  background: theme.backgroundDark,
  fontSize: "16px",
  color: theme.textDark,
  fontFamily: theme.formFont,
  padding: "4px 11px"
};

export const InputStyleStyled = css`
  width: 100%;
  height: 40px;
  border-radius: ${props => props.theme.borderRadiusContainers};
  background: ${props => props.theme.backgroundDark};
  font-size: 16px;
  color: ${props => props.theme.textDark};
  font-family: ${props => props.theme.formFont};
  padding: 4px 11px;
`;

export const lightInputStyle = {
  background: theme.backgroundTag,
  border: "none",
  borderRadius: theme.editor.containerRadius,
  color: theme.editor.textLight,
  fontFamily: theme.formFont,
  fontSize: "14px",
  padding: "4px 11px"
};
